<template>
	<div>
		<a-table :columns="columns" :dataSource="serviceList">
			<template slot="action" slot-scope="record">
				<a-popconfirm title="你确定要删除这个客服吗?" @confirm="confirm(record.id)" @cancel="cancel(record.id)" okText="Yes" cancelText="No">
					<a href="#">删除</a>
				</a-popconfirm>
			</template>
			<p slot-scope="record" style="margin: 0">{{ record.description }}</p>
		</a-table>

		<a-button class="editable-add-btn" type="primary" @click="handleAdd">添加客服</a-button>
		<a-modal title="Title" :visible="visible" @ok="handleOk" :confirmLoading="confirmLoading" @cancel="handleCancel">
			<a-form :form="form">
				<a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="姓名">
					<a-input v-decorator="['name', { rules: [{ required: true, message: '请输入姓名' }] }]" placeholder="请输入姓名" />
				</a-form-item>
				<a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="电话">
					<a-input v-decorator="['phone', { rules: [{ required: checkNick, message: '请输入电话' }] }]" placeholder="请输入电话" />
				</a-form-item>
			</a-form>
		</a-modal>
	</div>
</template>
<script>
const columns = [
	{ title: '姓名', dataIndex: 'name', key: 'name', width: '150px' },
	{ title: '电话', dataIndex: 'phone', key: 'phone', width: '150px' },
	{ title: '操作', dataIndex: '', key: 'x', scopedSlots: { customRender: 'action' } }
];

const data = [];

const formItemLayout = {
	labelCol: { span: 4 },
	wrapperCol: { span: 8 }
};
const formTailLayout = {
	labelCol: { span: 4 },
	wrapperCol: { span: 8, offset: 4 }
};


import api from '../../api/Api.js';

export default {
	data() {
		return {
			data,
			columns,
			visible: false,
			confirmLoading: false,
			checkNick: false,
			formItemLayout,
			formTailLayout,
			form: this.$form.createForm(this, { name: 'dynamic_rule' }),
			serviceList:[{ key: 2, name: '123', phone: '18507031438' }, { key: 3, name: '123', phone: '19806506548' }],
			page:0
		};
	},
	mounted(){
		this.getServiceList();
	},
	methods: {
		getServiceList(){
			const that = this;
			let url = 'api/commerce/v1/admin/serviceList';
			let parm = {
				page: this.page
			};
					
			api.postRequest(url, parm, res => {
				console.log(res);
					
				const rest = res.data;
				if (rest.status == 200) {		
					that.serviceListToTable(rest.data)
				} else {
					this.$message.error('服务器内部错误！');
				}
			});
		},
		serviceListToTable(serviceList){
			serviceList.forEach((item, index, array) => {
				item.key = index;
			});
			console.log(serviceList)
			this.serviceList = serviceList;
		},
		addService(){
			var that = this;
			
			let url = '/api/commerce/v1/admin/addService';
			let parm = this.data;
		
			api.postRequest(url, parm, res => {
				const rest = res.data;
				if (rest.status == 200) {
					that.addCompanyStyleWindow = false;
					that.getServiceList();
					that.resetForm();
					this.$message.success('添加成功！');
				} else {
					this.$message.error(rest.message);
				}
			});
		},
		resetForm() {
			this.form.resetFields();
		},
		handleAdd() {
			this.visible = true;
		},
		confirm(id) {
			
			const that = this;
			let url = 'api/commerce/v1/admin/deleteService';
			let parm = {
				id: id
			};
			api.postRequest(url, parm, res => {
				const rest = res.data;
				if (rest.status == 200) {
					this.$message.success('删除成功！');
					that.getServiceList()
				} else {
					this.$message.error('服务器内部错误！');
				}
			});
			
		},
		cancel(e) {
			this.$message.error('取消');
		},
		showModal() {
			this.visible = true;
		},
		handleOk(e) {
			var that = this;
			this.checkNick = e.target.checked;
			
			e.preventDefault();
			that.form.validateFields((err, values) => {
				if (!err) {
					that.data = {
						phone:values.phone,
						name: values.name,
					};
					that.addService();
				}
			
				return new Promise((resolve, reject) => {
					setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
				}).catch(() => console.log('Oops errors!'));
			});
			
			this.confirmLoading = true;
			setTimeout(() => {
				this.visible = false;
				this.confirmLoading = false;
			}, 1000);
		},
		handleCancel(e) {
			console.log('Clicked cancel button');
			this.visible = false;
		}
	}
};
</script>
<style>
.editable-add-btn {
	margin-bottom: 8px;
}
</style>
